import React from 'react'

import config from '../config'
import styles from './Footer.module.css'

export default () => (
  <div className={styles.container}>
    <div className={styles.content}>

      <div className={styles.contact}>
        <h5>Contact Us</h5>
        <a href={`mailto:${config.mail}`}>{config.mail}</a>
        <a href={config.messenger}>Messenger</a>
        <br />
        <a href={config.twitter}>Twitter</a>
        <a href={config.github}>GitHub</a>
        <a href={config.dribbble}>Dribbble</a>
        <a href={config.instagram}>Instagram</a>
      </div>

      <div className={styles.visit}>
        <h5>Visit Us</h5>
        <a href={config.adress}>Bowtie AB <br /> Mäster Mikaels gata 2B <br/> Stockholm, Sweden</a>
        <div className={styles.illustration} />
      </div>

      <div className={styles.credits}>
        <h5>© {new Date().getFullYear()} Bowtie AB</h5>
        <span className={styles.madeWithLove}>Made with Love & Lego in</span>
      </div>

    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Footer.js